module.exports = __webpack_public_path__ + "images/icons/ic-handle-7b27b3ac827db2885995aa09a39c111a.png";